import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import T from "components/T";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {getAutocomplete} from "utils/addressUtils";

interface ReservationDetailInputProps {
    placeholder?: string;
    value?: string;
    disabled?: boolean;
    name: string;
    register?: any;
    className?: string;
    classNameInput?: string;
    type?: string;
    errors?: FieldErrors;
    label?: string;
    required?: boolean;
    style?: "normal" | "inline";
    id?: string;
}

const ReservationDetailInput = (props: ReservationDetailInputProps) => {
    const {t} = useTranslation();
    return (
        <div
            className={clsx(
                "ReservationDetailInput w-full",
                props?.style === "inline" && "sm:flex sm:flex-row sm:space-x-6 sm:items-center sm:flex-wrap",
                props.className
            )}
        >
            {props.label && (
                <label
                    className={clsx("font-medium mb-1.5 flex text-base md:text-base text-black", props.errors?.[props.name] && "text-red-500")}
                    htmlFor={props.id ?? "label-" + props.name}
                >
                    <span>{t(props.label)}</span>
                    {props.required && <em className={"text-red-500"}>*</em>}
                </label>
            )}
            <input
                autoComplete={getAutocomplete(props.name)}
                {...(props?.register && {...props?.register(props.name)})}
                className={clsx(
                    "w-full px-3 py-2 rounded-[5px] border-arbo-borderGray text-black border text-base md:text-base font-medium",
                    props.errors?.[props.name] && "border-red-500",
                    props.disabled && "bg-gray-100 text-gray-600",
                    props.classNameInput
                )}
                disabled={props.disabled}
                id={props.id ?? "label-" + props.name}
                name={props.name}
                placeholder={props.placeholder}
                type={props?.type ? props.type : "text"}
            />
            {props.errors?.[props.name]?.message && (
                <div className={clsx("text-red-500 text-sm mt-1 flex flex-row items-center")}>
                    <div className={clsx("shrink-0 flex flex-row items-center text-xs md:text-base w-full")}>
                        <ExclamationCircleIcon className={"size-[14px] md:size-[18px] flex-none mr-0.5"} />
                        <T>{props.errors?.[props.name]?.message}</T>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReservationDetailInput;
